import React from 'react'
import { Modal } from 'react-bootstrap'
import Button from '@components/common/Button/Button.component'
import { IPhases } from '@dataTypes/treatmentPlan.types'
import { formatPresetToothNumsLabel } from '@utils/tx-plan-tooth-details.utils'
import './TxPlanToothPhasePicker.css'

export type TxPlanToothPhasePickerOption = {
  phaseIndex: number
  phaseName: string
}

interface TxPlanToothPhasePickerProps {
  show: boolean
  toothNums: number[]
  phases: TxPlanToothPhasePickerOption[]
  onSelectPhase: (phaseIndex: number) => void
  onAddNewPhase: () => void
  onHide: () => void
}

const TxPlanToothPhasePicker: React.FC<TxPlanToothPhasePickerProps> = ({
  show,
  toothNums,
  phases,
  onSelectPhase,
  onAddNewPhase,
  onHide,
}): React.ReactElement => {
  const toothLabel = formatPresetToothNumsLabel(toothNums)
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="sm"
      className="tx-plan-tooth-phase-picker-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Add to phase</Modal.Title>
      </Modal.Header>
      <Modal.Body className="tx-plan-tooth-phase-picker-body">
        {toothLabel ? (
          <p className="tx-plan-tooth-phase-picker-teeth">{toothLabel}</p>
        ) : null}
        <p className="tx-plan-tooth-phase-picker-hint mb-3">
          Choose which phase should receive the new procedures.
        </p>
        <div className="tx-plan-tooth-phase-picker-list d-flex flex-column gap-2">
          {phases.map((phase) => (
            <Button
              key={phase.phaseIndex}
              className="button-secondary tx-plan-tooth-phase-picker-btn"
              onClick={() => onSelectPhase(phase.phaseIndex)}
            >
              {phase.phaseName}
            </Button>
          ))}
          <button
            type="button"
            className="tx-plan-tooth-phase-picker-add-phase"
            onClick={onAddNewPhase}
          >
            <i className="mgc_add_line" aria-hidden />
            <span>Add new phase</span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export const getVisibleTxPlanPhasePickerOptions = (
  phases: IPhases[],
  phaseVisibility: Record<string, boolean>,
): TxPlanToothPhasePickerOption[] => {
  const options: TxPlanToothPhasePickerOption[] = []
  phases.forEach((phase, phaseIndex) => {
    if (phase.is_hidden) {
      return
    }
    const phaseId = phase.phase_id || ''
    if (phaseVisibility[phaseId] === false) {
      return
    }
    options.push({
      phaseIndex,
      phaseName: phase.phase_name?.trim() || `Phase ${phaseIndex + 1}`,
    })
  })
  return options
}

export default TxPlanToothPhasePicker
